import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import { previewPanels } from "../data/site";
import { LockedArtFrame } from "./LockedArtFrame";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

export function PanelPreview() {
  const [active, setActive] = useState(0);
  const panel = previewPanels[active];

  const move = (direction) => {
    setActive((current) => (current + direction + previewPanels.length) % previewPanels.length);
  };

  return (
    <section id="preview" className="preview-section" data-testid="panel-preview-section">
      <SectionHeading
        eyebrow="02 / READER PREVIEW"
        title="The first chapter pages are live."
        text="The variant key art transmission leads, followed by seven official black-and-white Volume 1 pages beginning at the Wasteland Feeding Hall."
      />
      <Reveal className="panel-reader" delay={0.12}>
        <div className="panel-toolbar">
          <span data-testid="active-panel-code">{panel.code}</span>
          <strong data-testid="active-panel-label">{panel.label}</strong>
        </div>
        <div className="panel-viewport">
          <div className="panel-track" style={{ transform: `translateX(-${active * 100}%)` }}>
            {previewPanels.map((item, index) => {
              const panelImage = item.image;
              return (
                <article className="panel-slide" key={item.id}>
                  {panelImage ? (
                    <figure className="panel-art-frame">
                      <img loading="lazy"
                        src={panelImage}
                        alt={`${item.code} official Dolo: Wasteland Runner first-chapter page`}
                        data-testid={`panel-image-${item.id}`}
                      />
                    </figure>
                  ) : (
                    <LockedArtFrame
                      code={`PANEL ${item.id}`}
                      title="OFFICIAL PANEL LOCKED"
                      note={item.note}
                      className="manga-panel-frame"
                    />
                  )}
                </article>
              );
            })}
          </div>
        </div>
        <div className="panel-controls">
          <button type="button" onClick={() => move(-1)} data-testid="panel-previous-button" aria-label="Previous panel">
            <ChevronLeft size={20} />
          </button>
          <div className="panel-dots" aria-label="Panel position">
            {previewPanels.map((item, index) => (
              <button
                type="button"
                key={item.id}
                className={index === active ? "is-active" : ""}
                onClick={() => setActive(index)}
                data-testid={`panel-dot-${item.id}`}
                aria-label={`Show panel ${item.id}`}
              />
            ))}
          </div>
          <button type="button" onClick={() => move(1)} data-testid="panel-next-button" aria-label="Next panel">
            <ChevronRight size={20} />
          </button>
        </div>
      </Reveal>
    </section>
  );
}
